/**
 * Converts milliseconds to hours in terms of time (0-24)
 */
export const msToHoursInTime = (ms: number): number => Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))

/**
 * Converts milliseconds to minutes in terms of time (0-60 mins)
 */
export const msToMinutesInTime = (ms: number): number => Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60))

/**
 * Converts milliseconds to seconds in terms of time (0-60 seconds)
 */
export const msToSecondsInTime = (ms: number): number => Math.floor((ms % (1000 * 60)) / 1000)
